/**
 * Permission names the web app checks. The API is the authority
 * (apps/api/src/common/permissions.ts, sent in auth/me); this list only names them so
 * routes and menus can be guarded. A name the API never grants just hides the menu
 * entry — it never opens anything. Cabinet/folder grants are enforced by the API.
 * Aligned with D1 (docs/sprints/D1.md "Differences").
 */
export const P = {
  docsView: 'documents.view',
  docsUpload: 'documents.upload',
  docsEdit: 'documents.edit',
  docsDelete: 'documents.delete',
  docsPurge: 'documents.purge',
  docsDownload: 'documents.download',
  docsPrint: 'documents.print',
  docsShare: 'documents.share',
  docsAllCabinets: 'documents.allCabinets',
  inboxReview: 'inbox.review',
  cabinetsManage: 'cabinets.manage',
  typesManage: 'types.manage',
  tagsManage: 'tags.manage',
  correspondentsManage: 'correspondents.manage',
  rulesManage: 'rules.manage',
  retention: 'retention.manage',
  holds: 'holds.manage',
  dispositionPropose: 'disposition.propose',
  dispositionApprove: 'disposition.approve',
  approvals: 'approvals.decide',
  workflows: 'workflows.manage',
  /** e-Sign: start signing requests (FR-ADM-02; Editor and above by default). */
  esignSend: 'esign.send',
  reports: 'reports.view',
  audit: 'audit.view',
  integrity: 'integrity.view',
  evidence: 'evidence.export',
  users: 'users.manage',
  groups: 'groups.manage',
  roles: 'roles.manage',
  grants: 'grants.manage',
  /** Organisation settings, including the share-link policy. */
  settings: 'settings.manage',
  supportApprove: 'support.approve',
  apiKeys: 'apikeys.manage',
  importRun: 'import.run',
  platformOrgs: 'platform.orgs',
  platformSupport: 'platform.support',
  platformHealth: 'platform.health',
} as const;

export type PermissionName = (typeof P)[keyof typeof P];
